import { useEffect, useState } from "react";
import { adminApi, getToken, clearToken } from "../lib/adminApi";
import AdminLogin from "../components/admin/AdminLogin";
import AdminShell from "../components/admin/AdminShell";

export default function Admin() {
  const [admin, setAdmin] = useState(null);

  useEffect(() => {
    if (!getToken()) {
      setAdmin(false);
      return;
    }
    adminApi
      .get("/auth/me")
      .then((r) => setAdmin(r.data))
      .catch(() => {
        clearToken();
        setAdmin(false);
      });
  }, []);

  const logout = () => {
    clearToken();
    setAdmin(false);
  };

  if (admin === null) {
    return (
      <div data-testid="admin-loading" className="min-h-screen flex items-center justify-center">
        <p className="text-[11px] font-mono tracking-[0.3em] uppercase text-stone-500 animate-pulse">Verifying access…</p>
      </div>
    );
  }

  if (!admin) return <AdminLogin onSuccess={setAdmin} />;
  return <AdminShell admin={admin} onLogout={logout} />;
}
